import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

import { Theme } from 'ui_system/theme';
import { NavLink } from './NavLink';
import { PROFILE } from '../routes/routes';

const Container = styled.div`
  width: 100%;
  background: white;
  position: absolute;
  z-index: 2;

  font-size: 16px;
  text-align: center;

  display: ${(props) => (props.visible ? 'block' : 'none')};
`;

const Section = styled.div`
  padding: 15px;
  border-bottom: 1px solid ${Theme.colors.lightLine};
  color: ${(props) => (props.color ? props.color : props.theme.linkColor)};
`;

const HeaderMobileDropdown = ({
  open,
  onLogout,
  onLinkClick,
  showSupportLink,
  supportLink,
  linkColor,
}) => {
  return (
    <Container visible={open}>
      <Link onClick={onLinkClick} to={PROFILE}>
        <Section>
          <NavLink color={linkColor}>My Profile</NavLink>
        </Section>
      </Link>
      {showSupportLink && (
        <a
          onClick={onLinkClick}
          target="_blank"
          rel="noopener noreferrer"
          href={supportLink}
        >
          <Section>
            <NavLink color={linkColor}>Support</NavLink>
          </Section>
        </a>
      )}
      <NavLink
        linkColor
        onClick={() => {
          onLogout();
          onLinkClick();
        }}
      >
        <Section color={linkColor}>Logout</Section>
      </NavLink>
    </Container>
  );
};

HeaderMobileDropdown.defaultProps = {
  open: false,
  onLogout: () => {},
  onLinkClick: () => {},
  showSupportLink: false,
  supportLink: null,
};

HeaderMobileDropdown.propTypes = {
  open: PropTypes.bool,
  onLogout: PropTypes.func,
  onLinkClick: PropTypes.func,
  showSupportLink: PropTypes.bool,
  supportLink: PropTypes.string,
};

export default HeaderMobileDropdown;
